import React, { memo } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  Container,
  Row,
  Col,
  HeadingText,
  BodyText,
  Link,
  Tile,
} from '@paypalcorp/pp-react'
import { principlesConfig } from '../../config/privacy-hub'
import serverData from '../../utils/server-data'

const PrivacyPrinciplesSection = memo(() => (
  <Container className="privacy-hub-principles-section-container">
    <Row noGutters>
      <Col xs={12} md={6} className="privacy-hub-col-spacing">
        <HeadingText
          size="hero"
          className="privacy-hub-display-text"
          id="privacyhubPrinciplePageHeader"
        >
          <Message id="privacyhub.principles.privacyprinciples.title" />
        </HeadingText>
        <BodyText
          className="privacy-hub-body-text privacy-hub-principles-description"
          id="privacyhubPrinciplePageDesc"
        >
          <Message
            id="privacyhub.principles.privacyprinciples.desc"
            link={(innerMessage) => (
              <Link target="_blank" className="privacy-hub-hyper-link">
                {innerMessage}
              </Link>
            )}
          />
        </BodyText>
      </Col>
      <Col
        xs={{ order: 1, span: 12 }}
        md={{ order: 2, span: 6 }}
        className="privacy-hub-business-image-container privacy-hub-text-align-center"
      >
        <img
          className="privacy-hub-business-image"
          src={`https://${serverData.cdnHostName}/privacyhub/compass-illustration.svg`}
          alt="CompassImage"
        />
      </Col>
    </Row>
  </Container>
))
PrivacyPrinciplesSection.displayName = 'PrivacyPrinciplesSection'

const PrivacyHubKeyTakeawaysSection = memo(() => (
  <Container className="privacy-hub-main-link-section-container">
    <Row noGutters>
      {principlesConfig.KeyTakeaways.map(({ id, img, title, description }) => (
        <Col className="privacy-hub-main-link-item" xs={12} md={6} key={title}>
          <Container fluid>
            <Row noGutters>
              <Col
                md={3}
                className="privacy-hub-main-link-item-image-container"
              >
                <img src={img.src} alt={img.alt} className={img.classname} />
              </Col>
              <Col md={9}>
                <BodyText
                  strong
                  className="privacy-hub-body-title-text"
                  id={`${id}Title`}
                >
                  <Message id={title} />
                </BodyText>
                <BodyText
                  className="privacy-hub-body-text privacy-hub-main-link-item-description"
                  id={`${id}Desc`}
                >
                  <Message id={description} />
                </BodyText>
              </Col>
            </Row>
          </Container>
        </Col>
      ))}
    </Row>
  </Container>
))
PrivacyHubKeyTakeawaysSection.displayName = 'PrivacyHubKeyTakeawaysSection'

const PrivacyHubHorizantalCardsSection = () => {
  const renderCard = (item) => {
    const { title } = item

    return (
      <div className="privacy-hub-horizontal-card-item">
        <Tile className="horizantal-content" size="xs" card>
          <Tile.Content>
            <div className="horizantal-body-content">
              {' '}
              <HeadingText
                size="lg"
                className="privacy-hub-large-text"
                id={item.id}
              >
                <Message id={title} />
              </HeadingText>
            </div>
          </Tile.Content>
        </Tile>
      </div>
    )
  }

  return (
    <Container className="privacy-hub-card-section-container">
      <Row noGutters className="privacyhub-horizantal-row">
        {principlesConfig.horizantalCardsConfig.map((item) => (
          <Col
            key={item.id}
            xs={12}
            lg={4}
            className="privacy-hub-horizontal-col"
          >
            {renderCard(item)}
          </Col>
        ))}
      </Row>
    </Container>
  )
}
PrivacyHubHorizantalCardsSection.displayName =
  'PrivacyHubHorizantalCardsSection'

const PrivacyHubPrinciples = memo(() => (
  <div id="privacy-hub-principles">
    <PrivacyPrinciplesSection />
    <PrivacyHubHorizantalCardsSection />
    <PrivacyHubKeyTakeawaysSection />
  </div>
))

PrivacyHubPrinciples.displayName = 'PrivacyHubPrinciples'

export default PrivacyHubPrinciples
